







































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Dialog, Toast } from "vant";

const couponModule = namespace("coupon");

@Component
export default class SearchDetail extends Vue {
	couponDetail: any = {};
	infoEffectiveConditionLimit: string = "";
	couponEffectiveStartTime: string = "";
	couponEffectiveEndTime: string = "";
	infoEffectiveDate: string = "";

	mounted() {
		this.getCouponID();
	}
	getCouponID() {
		this.$store.commit("coupon/setcouponSearchStep", 2);
		if (this.$route.query.sancode) {
			this.handleSearchClick();
		} else {
			this.$router.push(`/couponVerification/search`);
		}
	}

	handleConfirmClick() {
		Dialog.confirm({
			title: "确认核销",
			message: `券码：${this.couponDetail.couponInstanceQrCode}`
		})
			.then(() => {
				this.handleSearchClick(true, 1);
			})
			.catch(() => {});
	}

	async handleSearchClick(jump: boolean = false, item: number = 0) {
		console.log(this.couponDetail);
		this.$store.commit(
			"coupon/setEffectiveQrCode",
			this.$route.query.sancode
		);
		const { error, success } = await this.$store.dispatch(
			"coupon/getEffectiveCouponEntity",
			item
		);
		if (success) {
			if (jump) {
				const couponDetail: any = this.couponDetail;
				this.$router.replace({
					path: `/couponVerification/success`,
					query: {
						id: couponDetail.couponId,
						qrCode: couponDetail.couponInstanceQrCode,
						writeOffTime: success.data.writeOffTime,
						couponMainInfo: couponDetail.couponMainInfo,
						couponExtendInfo: couponDetail.couponExtendInfo,
						couponInstanceQrCode: couponDetail.couponInstanceQrCode,
						couponActivityName: couponDetail.couponActivityName
					}
				});
			} else {
				let data = success.data.coupon;
				this.infoEffectiveDate = [
					[
						(data.couponEffectiveStartTime || "").replace(
							/-/g,
							"."
						),
						(data.couponEffectiveEndTime || "").replace(/-/g, ".")
					].join("-"),
					data.couponActivedLimitedStartDay == 0 &&
					data.couponActivedLimitedDays == 1
						? "仅当天有效"
						: (data.couponActivedLimitedStartDay == 0
								? "领取后当天开始(含当天)有效"
								: "领取后" +
								  (data.couponActivedLimitedStartDay + 1 > 0
										? "第" +
										  (data.couponActivedLimitedStartDay +
												1) +
										  "天开始(含当天)有效"
										: "当天开始有效")) +
						  ", 有效期" +
						  data.couponActivedLimitedDays +
						  "天",
					[data.couponGetStartTime, data.couponGetEndTime].join("至")
				][data.couponEffectiveSwitch];
				this.couponDetail = success.data.coupon;
			}
		} else {
			Toast(error.msg);
			if (this.$route.query.sancode) {
				this.$router.back();
			} else {
				this.$router.push({ path: `/couponVerification/search` });
			}
		}
	}
}
